import {
    apijhiusersoperatePriceApproval,
    apitombstombChangePriceByGroupId
  } from '@/api/sys/adjustment'
  export default {
    namespaced: true,
    actions: {
        apijhiusersoperatePriceApproval(context,data){
            console.log(data);
           return apijhiusersoperatePriceApproval(data).then((res) => {
                  return res;
              }).catch(err => {
                console.log('err: ', err)
              })
        },
        apitombstombChangePriceByGroupId(context,data){
            console.log(data)
            return apitombstombChangePriceByGroupId(data).then((res) =>{
              console.log('ss');
                return res;
            })
            .catch(err => {
              console.log('err: ', err)
            })
        }
    }
}